import axios from 'axios';
import { Observable, Observer, Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';

export default class RequestService {
  public getCityByLngLat(lngLat: {lng: number, lat: number}): any {
    const payload = {
      url: 'https://api.opencagedata.com/geocode/v1/json',
      parameters: [
        {
          key: 'key',
          value: 'a8c310b9ec094c0eb863d4c8febecb25'
        },
        {
          key: 'q',
          value: encodeURIComponent(`${lngLat.lat}, ${lngLat.lng}`)
        },
        {
          key: 'pretty',
          value: '1'
        },
        {
          key: 'no_annotations',
          value: '1'
        }
      ]
    };
    return this.get(payload)
      .pipe(map((res: any) => {
        return res.data.results[0].components;
      }));
  }

  private get(payload: any): Observable<string> {
    let url = payload.url;
    if (payload.parameters) {
      url = this.addParameters(payload.url, payload.parameters);
    }

    const obs = Observable.create((observer: Observer<string>) => {
      axios
        .get(url)
        .then((response: any) => {
          observer.next(response);
        });
      });

    return obs;
  }

  private addParameters(url: string, params: any[]) {
    url = `${url}?`;
    params.forEach((param: {key: string, value: string}, index: number) => {
      if (index !== 0) {
        url += '&';
      }
      url += `${param.key}=${param.value}`;
    });
    return url;
  }
}
